import useSessionProvider from 'providers/SessionProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const ThankYou = () => {
    const { i18n } = useTranslation();
    const { survey } = useSessionProvider();
    useEffect(() => {
        document.body.classList.remove('body--survey')
    }, [])

    function replaceURLWithHTMLLinks(text) {
        if (text && text.length > 0) {
            var exp = /(\b(http|ftp|https):\/\/([\w-]+\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?)/ig;
            return `<p>${text[0]?.replace(exp, "<a href='$1'>$3</a>")}</p>`;
        }
        return `<p> </p>`
    }
    return (
        <div className="container container-md">
            <div className="thank-you">
                <div className="thankyou__image">
                    {survey?.thankyouPage?.banner && <img src={survey?.thankyouPage?.banner} alt="Thank You Banner" />}
                </div>
                <div className="thankyou__content">
                    <div className="thankyou--icon ">
                        <i className="fa-light fa-thumbs-up"></i>
                    </div>

                    <div dangerouslySetInnerHTML={{ __html: survey?.thankyouPage?.text[i18n.language] }}></div>
                </div>
            </div>
            <div className="thankyou--footer">
                <div className="thankyou--footer">
                    {survey?.thankyouPage?.social && (
                        <ul className="social-list">
                            {survey?.thankyouPage?.social &&
                                survey.thankyouPage?.twitter &&
                                survey?.thankyouPage?.twitterUrl && (
                                    <li>
                                        <a
                                            className="twitter"
                                            href={survey?.thankyouPage?.twitterUrl}
                                            target="_blank"
                                            rel="noreferrer">
                                            <i className="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>
                                )}
                            {survey?.thankyouPage?.social &&
                                survey.thankyouPage?.youtube &&
                                survey?.thankyouPage?.youtubeUrl && (
                                    <li>
                                        <a
                                            className="youtube"
                                            href={survey?.thankyouPage?.youtubeUrl}
                                            target="_blank"
                                            rel="noreferrer">
                                            <i className="fa-brands fa-youtube"></i>
                                        </a>
                                    </li>
                                )}
                            {survey?.thankyouPage?.social &&
                                survey.thankyouPage?.linkedIn &&
                                survey?.thankyouPage?.linkedInUrl && (
                                    <li>
                                        <a
                                            className="linkedin"
                                            href={survey?.thankyouPage?.linkedInUrl}
                                            rel="noreferrer"
                                            target="_blank">
                                            <i className="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ThankYou;
